import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import RegisterViaLink from "./RegisterViaLink";
import CustomRegister from "../../components/pages/customRegister/CustomRegister";
import { captureUtmParams } from "../../components/pages/customRegister/utmCapture";

export default function RegistrationRouter() {
  const [searchParams] = useSearchParams();
  const { processId } = useParams<{ processId: string }>();
  const hasConfig = searchParams.has("config");

  useEffect(() => {
    if (processId) {
      captureUtmParams(processId, window.location.search);
    }
  }, [processId]);

  return hasConfig ? <CustomRegister /> : <RegisterViaLink />;
}
